import Base from "@/services/Base";
import qs from "qs"

export default class Event extends Base {
    constructor() {
        super();
    }

    async get(filters: object) {
        const response: any = await this.http.get(`/events?${qs.stringify(filters)}`);
        return response.data;
    }

    async find(id: number) {
        const response: any = await this.http.get(`/events/${id}`);
        return response.data;
    }

    async save(id: number, data: object) {
        const response: any = await this.http.post(`/events/${id}/save`, data);

        return response.data;
    }
}